<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            title="确认订单"
            left-arrow
            @click-left="$router.go(-1)"
        />

        <van-card style="background: white;"
        >
            <template v-if="product.productCatNames" #tags>
                <van-tag size="large" plain style="margin-left: 4px; margin-top: 4px;" v-for="cat1 in product.productCatNames.split(',')"
                         color="var(--color)">{{ cat1 }}
                </van-tag>
            </template>
            <template #title>
                <div style="font-size: 16px;">{{ product.name }}</div>
            </template>
            <template #price>
                <div style="color: var(--color); font-size: 20px; margin-top: 4px;">￥{{ (product.priceInCent / 100).toFixed(2) }}</div>
            </template>
            <template v-if="product.priceInCent!==product.priceOriginal" #origin-price>
                <div style="font-size: 20px; margin-top: 4px;">￥{{ (product.priceOriginal / 100).toFixed(2) }}</div>
            </template>
            <template #num>
                <van-stepper v-model="num" min="1" max="999"/>
            </template>
            <template #thumb>
                <van-image :src="baseCdnUrl+'/api/public/product_'+product.id+'.jpg'"/>
            </template>
            <template #desc>
                <div style="margin-top: 4px;">{{ product.summary }}</div>
            </template>
        </van-card>

        <van-notice-bar v-if="product.coupon && product.coupon.time>0" wrapable left-icon="fire-o" :scrollable="false">
            <template #default>
                <div>
                    专属<span style="font-weight: 600;font-size: 20px;">{{product.coupon.discountDesc}}</span>{{ product.coupon.discountDesc2 }}，限时价：<span>￥</span><span style="font-size: 20px; font-weight: 600;">{{product.priceDesc2}}</span>
                    <div v-if="product.coupon.time<2592000000">
                        优惠剩余时间：<van-count-down style="display: inline-block;color: #ED6A0C;font-weight: 600; font-size: 16px;" :time="product.coupon.time" />
                    </div>
                </div>
            </template>
        </van-notice-bar>

        <div v-if="product.productAdds.length>0">
            <div style="padding: 10px; ">可选择附加检测项</div>
            <van-checkbox-group v-model="adds">
                <van-cell-group>
                    <van-cell
                        v-for="(add, index) in product.productAdds"
                        clickable
                        :key="add.id"
                        :title="add.name"
                        @click="toggleProductAdd(index)"
                    >
                        <template #right-icon>
                            <van-checkbox checked-color="var(--color)" :name="add.id" ref="checkboxes"/>
                        </template>
                        <template #label>
                            <div>
                                <div class="van-card__price">
                                    <div style="color: rgb(255, 131, 22); font-size: 16px;">
                                        ￥{{ (add.priceInCent / 100.0).toFixed(2) }}
                                    </div>
                                </div>
                                <div v-if="add.priceInCent!==add.priceOriginal" class="van-card__origin-price">
                                    <div style="font-size: 16px;">￥{{ (add.priceOriginal / 100.0).toFixed(2) }}</div>
                                </div>
                            </div>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </div>

        <van-field style="margin-top: 10px;"
                   v-model="refererNo"
                   maxlength="50"
                   label="推荐顾问"
                   placeholder="可填写推荐顾问姓名或号码"
        />

        <van-field style="margin-top: 10px;"
                   v-model="couponCode"
                   maxlength="6"
                   label="折扣券代码"
                   placeholder="可填写您的专属折扣券"
        />

        <van-submit-bar
            :loading="loading"
            :price="priceInCent"
            button-text="去支付"
            @submit="checkIdCardAndSubmit"
        />

        <van-dialog v-model="showIdCardDialog" :beforeClose="saveIdCardClicked" title="身份证号" show-cancel-button>
            <div style="padding: 10px; font-size: 14px;">
                1. 根据相关政策，进行医疗检查需要实名登记，便于医疗机构病例管理；<br/>
                2. 您提交给本平台的信息资料，即不可撤销的授权由本平台保留。本平台承诺除法定或约定的事由外，不公开或编辑或透露您的信息给第三方平台以用于商业目的，但下列情况除外： 1) 本平台向国家司法及行政机关提供； 2) 第三方和本平台一起为用户提供服务时，该第三方向您提供服务所需的相关信息。<br/>
                3. 我们将采取合理的方式以保护您个人资料的安全，保护您的个人资料不被未经授权的访问、使用或泄漏。<br/>
            </div>
            <van-field
                v-model="idCard"
                label="身份证号："
                maxlength="18"
                placeholder="请输入18位身份证号"
            />
        </van-dialog>
    </div>
</template>

<script>
import http, {BASE_CDN_URL, BASE_URL} from "@/utils/http";
import qs from "qs";
import {Notify, Toast} from "vant";
import moment from "moment";

export default {
    name: "ProductOrder",
    data() {
        return {
            baseUrl: BASE_URL,
            baseCdnUrl: BASE_CDN_URL,
            refreshing: false,
            loading: false,
            finished: false,
            idCard: '',
            keywords: '',
            product: {name: '', id: 0, priceInCent: 0, productAdds: []},
            num: 1,
            refererNo: '',
            priceInCent: 0,
            list: [],

            couponCode: localStorage.getItem("couponCode"),

            adds: [],
            activeTab: 0,
            oid: '',
            payRequest: null,
            payRequestExpireTime: 0,
            orderNo: '',
            orderKey: '',//区分取消支付后再支付，是不是和上一次一样，没有修改过

            quickButtonShow: false,
            showIdCardDialog: false,
        };
    },
    watch: {
        num: function (value) {
            this.calcPrice();
        },
        adds: function (value) {
            this.calcPrice();
        },
        couponCode: function(value) {
            if(value && value.length===6){
                this.loadDetail(this.product.id, (product) => {
                    this.product = product;
                    this.calcPrice();
                    // console.log(this.product)
                });
            }else{
                delete this.product['coupon'];
                this.calcPrice();
            }
        }
    },
    created() {
        this.product.id = this.$route.query.id ? this.$route.query.id : '';
        this.oid = this.$route.query.oid ? this.$route.query.oid : '';
        if (!this.product.id || !this.oid) {
            this.$router.replace("/");
            return;
        }
        this.loadDetail(this.product.id, (product) => {
            if(product.intro) {
                // /api/product/ue/image换成 baseurl/api/product/ue/image/
                product.intro = product.intro.replace(/\/api\/product\/ue\/image\//g, this.baseCdnUrl + '/api/product/ue/image/');
            }
            this.product = product;
            this.calcPrice();
            // console.log(this.product)
        });
    },
    methods: {
        toggleProductAdd(index) {
            this.$refs.checkboxes[index].toggle();
        },
        calcPrice() {
            var number = parseInt(this.num + '');
            var price = number * this.product.priceInCent;
            if(this.product.coupon) {
                if(this.product.coupon.minus>0){
                    price = price - this.product.coupon.minus;
                } else {
                    price = price * this.product.coupon.discount / 100;
                }
                if(price < 0) {
                    price = 0;
                }
            }
            if (this.adds && this.adds.length > 0) {
                for (var i = 0; i < this.adds.length; i++) {
                    var foundedProductAdd = this.product.productAdds.find(item => item.id === this.adds[i]);
                    if(foundedProductAdd) {
                        price = price + foundedProductAdd.priceInCent * number;
                    }
                }
            }
            this.priceInCent = price;
        },
        loadDetail(productId, callback) {
            let payload = qs.stringify({id: productId, couponCode: this.couponCode});
            http.post('/api/public/product_detail', payload).then(res => {
                if (callback) {
                    var product = res.data.extra.product;
                    if(product.coupon) {
                        product.coupon.time = moment(product.coupon.validTo).valueOf() - moment().valueOf();
                        product.coupon.discountDesc = product.coupon.discount % 10 === 0 ? product.coupon.discount / 10 : product.coupon.discount;
                        if(product.coupon.minus > 0) {
                            product.coupon.discountDesc = (product.coupon.minus / 100).toFixed(2);
                        }
                        product.coupon.discountDesc2 = product.coupon.minus>0?'元立减券':'折折扣券';
                        product.priceDesc2 = product.coupon.minus>0?((product.priceInCent>product.coupon.minus?(product.priceInCent-product.coupon.minus):0)/100).toFixed(2):(product.priceInCent * product.coupon.discount / 10000).toFixed(2);
                    }
                    callback(product);
                }
                // console.log(res)
            });
        },
        checkIdCardAndSubmit() {
            this.submitOrderClicked();

            // this.loading = true;
            // http.get('/api/personal/load_user_profile').then(res => {
            //     this.loading = false;
            //     if (!res.data.result) {
            //         Notify({type: 'danger', message: res.data.message});
            //     } else {
            //         if (!res.data.extra.user.idCardMasked) {
            //             this.showIdCardDialog = true;
            //         } else {
            //             this.submitOrderClicked();
            //         }
            //     }
            // });
        },
        saveIdCardClicked(action, done) {
//             调用 done() 后关闭弹窗，调用 done(false) 阻止弹窗关闭
            if (action === 'confirm') {
                this.updateIdCard((data) => {
                    // console.log(data)
                    if (!data.result) {
                        Notify({type: 'danger', message: data.message});
                        done(false);
                    } else {
                        Notify({type: 'success', message: data.message});
                        this.user = data.extra.user;
                        localStorage.setItem("user", JSON.stringify(data.extra.user));
                        done();

                        this.submitOrderClicked();
                    }
                })
            } else {
                done();
            }
        },
        updateIdCard(callback) {
            var payload = {column: "idCard", value: this.idCard};
            // console.log(payload)
            this.loading = true;
            http.post('/api/personal/update_user_profile', qs.stringify(payload)).then(res => {
                this.loading = false;
                callback(res.data);
            }).catch(() => this.loading = false);
        },
        submitOrderClicked: function () {
            // 如果用户取消了付款，再点，就直接进入doPay()
            var thisKey = this.product.id + ":" + this.num + ":" + this.adds.sort().join(",");
            if (this.payRequestExpireTime > moment().valueOf() && !this.orderKey) {
                if (thisKey === this.orderKey) {
                    this.doPay();
                    return;
                }
            }
            let payload = {
                productId: this.product.id, openId: this.oid , couponCode: this.couponCode,
                num: this.num, addIds: this.adds.sort().join(","), refererNo: this.refererNo,
                channelCode: localStorage.getItem('channel')
            };
            http.post('/api/personal/product_order', qs.stringify(payload)).then(res => {
                this.loading = false;
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                    if (res.data.extra.path) {
                        this.$router.push(res.data.extra.path);
                    }
                } else {
                    if(res.data.extra.totalFee <=0) {
                        Notify({type: 'success', message: res.data.message});
                        this.$router.replace('/my_goods_order_detail?id=' + res.data.extra.orderNo);
                    } else {
                        this.payRequest = res.data.extra.payRequest;
                        this.orderNo = res.data.extra.orderNo;
                        this.orderKey = thisKey;
                        this.payRequestExpireTime = res.data.extra.payRequestExpireTime;
                        this.doPay();
                    }
                }
            });
        },
        onBridgeReady() {
            // https://pay.weixin.qq.com/wiki/doc/api/jsapi.php?chapter=7_7&index=6
            WeixinJSBridge.invoke('getBrandWCPayRequest', this.payRequest, (res) => {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    Notify({type: 'success', message: '成功支付!'});
                    this.checkStateAndGoOrderDetail();
                } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                    Notify({type: 'warning', message: '已取消支付!'});
                } else {
                    Notify({type: 'warning', message: '支付失败!'});
                }
            });
        },
        doPay() {
            if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
            } else {
                this.onBridgeReady();
            }
        },
        checkStateAndGoOrderDetail() {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            http.get('/api/personal/order_transaction_check?orderId=' + this.orderNo).then(res => {
                Toast.clear();
                if (!res.data.result) {
                    Notify({type: 'danger', message: res.data.message});
                } else {
                    // res.data.extra.order里有信息，可以使用
                    this.$router.replace('/my_order_detail?id=' + this.orderNo);
                }
            });
        }
    },
}
</script>

<style scoped>

</style>